import BreadcrumbWrapper from '@Components/BreadcrumbWrapper';
import SubscriptionList from './SubscriptionTierList';

const SubscriptionTiers = () => {
  return (
    <div className="flex flex-col gap-4">
      <BreadcrumbWrapper
        crumbArray={[
          { path: '/subscription-tiers', label: 'Subscriptions Tiers' },
        ]}
      />

      <h1 className="text-2xl font-bold">Subscription Tiers</h1>
      <p>Manage Subscription Tiers</p>
      <SubscriptionList />
    </div>
  );
};

export default SubscriptionTiers;
